module.exports = __webpack_public_path__ + "static/media/Danamon.f6d5914e.png";